module.exports = __webpack_public_path__ + "assets/5418ecf09127de608fe754450f4f66eb.mp3";